<script>
import Topbar from "@/components/map/topbar";
import MakerInfo from "@/components/map/makerinfo.vue";
import InstructionInfo from "@/components/map/instructions.vue";
import appConfig from "@/app.config";
//import axios from "axios";
import fileGEO from '../../helpers/spain-communities.json';
import DirectionsRenderer from "@/components/map/DirectionsRenderer";
import iconMyPosition from "@/assets/images/icon-myposition.png";
import api from '@/helpers/api-rest/api.js';

/**
 * Google-map component
 */
export default {
  page: {
    title: "H2 Map",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Topbar, MakerInfo, InstructionInfo, DirectionsRenderer },
  data() {
    return {
      //mapCenter: { lat: 41.656060, lng: -0.877340 },
      mapCenter: { lat: 40.333333, lng: -4.187500 },
      destinationRoute: null,
      travelMode: "DRIVING",
      mapZoom: 6.5,
      markers: [],
      markersInfo: [],
      iconType: null,
      selectedMarker: null,
      showInfo: false,
      showRouteInfo: false,
      dataConsumers: [],
      selectedCompanies: [],
      //Options Map (Gmap)
      options: {
        mapId: '9582e7dfb5f80cf6',
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        clickableIcons: false
      },
      fileData: fileGEO,
      poligonos: [],
      myPosition: null,
      iconMyPosition: iconMyPosition,
      selectedRouteInfo: null,
      selectedRoute: null,
      selectedPolygon: null
    };
  },
  methods: {
    selectMarker(marker) {
      this.selectedMarker = marker;
      this.filterById(this.selectedMarker.id);
      this.mapZoom = 8.5;
    },
    calculateRoute() {
      if (this.selectedMarker && this.selectedMarker.position) {
        this.mapZoom = 10;
        this.destinationRoute = {
          lat: this.selectedMarker.position.lat,
          lng: this.selectedMarker.position.lng
        };
      } else {
        console.error('El marcador seleccionado no tiene las propiedades lat y lng necesarias.');
      }
    },
    resetMap() {
      this.mapZoom = 8;
      this.showRouteInfo = false;
      this.destinationRoute = null;
      this.selectedRoute = null;
    },
    closeInfo() {
      this.selectedMarker = null;
      this.loadDataMarkers();
      this.mapZoom = 8;
    },
    filterById(id){
      let filter = {};
      if(id !== null){  
        filter['id'] = id;
      }
      this.loadDataMarkers(filter);
    },
    filterMap(id){

      let filter = {};

      if(id !== null){  
        filter['company_type_id'] = id;
      }

      this.loadDataMarkers(filter);
    },
    showMarkerInfo(marker) {
        this.selectedMarker = marker;
        this.filterById(this.selectedMarker.id);
        this.mapZoom = 8.5;
        //this.loadDataMarkers(marker.id);
    },
    filterByName(searchQuery) {
      let filter = {};
      if(searchQuery !== null){  
        filter['name'] = searchQuery;
      }
      this.loadDataMarkers(filter);
    },
    loadDataMarkers(params={}){
      const user = JSON.parse(localStorage.getItem('user'));
      //const apiHost = process.env.VUE_APP_API_HOST;
      this.myPosition = {lat: parseFloat(user?.consumer_company[0]?.latitude), lng: parseFloat(user?.consumer_company[0]?.longitude)};
      //this.myPosition = {lat: parseFloat(40.4165000), lng: parseFloat(-3.7025600)};
      let apiEndpoint = "";
      if (user?.roles[0]?.slug === 'production') {
        apiEndpoint = `/api/v1/consumer-companies`;
      } else if (user?.roles[0]?.slug === 'consumer') {
        apiEndpoint = `/api/v1/production-companies`;
      }

      api.get({url:apiEndpoint, params: {
        ...params,
        'status': 1
      }})
        .then(response => {
          const newMarkers = response.data.map(item => ({
            id: item.id,
            position: {
              lat: parseFloat(item.latitude),
              lng: parseFloat(item.longitude),
            },
            location: {
              community: item?.autonomous_community?.name,
              province: item?.province?.name,
              municipality: item?.municipality?.name
            },
            icon: item.company_type.icon_url,
            name: item.name,
            address: item.address,
            postal_code: item.postal_code,
            type: item.company_type.name
          }));
          this.markers = newMarkers;
          this.markersInfo = newMarkers;

        })
        .catch(error => {
          console.error("Error fetching markers:", error);
        });
    },
    loadPolygonJSON(){
      const features = this.fileData.features;
      features.map(feature => {
        let polygon = [];
        let fillColor = feature.properties.fillColor ? feature.properties.fillColor : '#6e6e6e';
        let clickable = feature.properties.active ? true : false;
        let fillOpacity = feature.properties.active ? 0.6 : 0.4;

        feature.geometry.coordinates.map(coordinate => {
          coordinate.map(coor => {
            coor.map(c => {
              polygon.push({
                lat: c[1],
                lng: c[0],
              });
            })
          })
        });

        const polygonOptions = {
          paths: polygon,
          options: {
            strokeColor: '#00000029',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: fillColor,
            fillOpacity: fillOpacity,
            clickable: clickable
          },
          cod_ccaa: feature.properties.cod_ccaa,
          name: feature.properties.name,
          lat: feature.properties.latCenter,
          lng: feature.properties.lngCenter
        };

        this.poligonos.push(polygonOptions);
      })
      


    },
    onMapClick(event) {
      // Actualiza el centro del mapa con las coordenadas del clic
      this.mapCenter = event.latLng;

      //this.mapCenter = { lat: 40.4165000, lng: -3.7025600 };

      // Emite un evento personalizado para que el polígono lo maneje\@click="onMapClick"
      this.$refs.polygonRef.$emit('map-click', event);
    },
    onPolygonClick(poligono) {
      this.mapCenter = { lat: parseFloat(poligono.lat), lng: parseFloat(poligono.lng) };
      this.mapZoom = 8;
      poligono.options.fillColor = '#966767';
      //console.log(poligono);
      /* Filtro por comunidad */

      // let filter = {};

      // if(poligono.cod_ccaa !== null){  
      //   filter['autonomous_community_id'] = poligono.cod_ccaa;
      // }

      /* End Filtro por comunidad */
      this.showInfo = true;
      this.loadDataMarkers();
    },
    updateRoutes(newRoutes) {
      this.selectedRouteInfo = newRoutes;
    },
    selectRoute(route){
      this.selectedRoute = route;
    },
  },
  created() {
    this.loadPolygonJSON();

  },
};
</script>

<template>
  <div>
    <Topbar :showInfo="showInfo" @filter="filterMap" @search="filterByName" />
    <InstructionInfo v-if="showInfo == false"  />
    <gmap-map ref="map" :center="mapCenter" :options="options" :zoom="mapZoom" style="height: 100vh">
      <DirectionsRenderer :travelMode="travelMode" :origin="myPosition" :destination="destinationRoute" :selectedRoute="selectedRoute" @routes="updateRoutes" />
      <GmapPolygon
        v-for="(poligono, index) in this.poligonos"
        :key="'polygon_'+index"
        :paths="poligono.paths"
        :options="poligono.options"
        @click="onPolygonClick(poligono)"
        ref="polygonRef"
      />
      <gmap-marker
        v-for="(m, index) in markers"
        :key="index"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :icon="m.icon"
        @click="selectMarker(m)"
      >
      </gmap-marker>
      <gmap-marker :position="myPosition" :icon="iconMyPosition"></gmap-marker>
    </gmap-map>
    
    <MakerInfo v-if="showInfo" 
      :dataConsumers="markersInfo" 
      :selectedMarker="selectedMarker"
      :selectedRouteInfo="selectedRouteInfo"
      @close="closeInfo" 
      @calculate-route="calculateRoute" 
      @show-marker-info="showMarkerInfo"
      @reset-map="resetMap"
      @ruta-seleccionada="selectRoute"
    />
    
  </div>
</template>
